import React from "react";
import { useState } from "react";
import { ModalAlert } from "../../common/dialog/modalAlert";
import THead from "../../common/table/tHead";
import Table from "../../common/table/table";
import Tr from "../../common/table/tr";
import Td from "../../common/table/td";
import TBody from "../../common/table/tBody";
import Th from "../../common/table/th";
import Button from "../../common/button/button";

export function IndicadorLeiturasFaltando(props) {
    if (!props.visible || !props.item.consumoLeitura) return null;

    const [modalAberto, setModalAberto] = useState(false);
    return (
        <>
            <ModalAlert titulo="Leituras em Falta" handleClose={() => setModalAberto(false)} showModal={modalAberto} estiloTitulo={{ color: "#222" }}>
                <div style={{ color: "#222" }}>
                    <Table responsive>
                        <THead>
                            <Tr>
                                <Th style={{ fontSize: "0.9rem" }} alignCenter>
                                    Data/Hora da Leitura Inicial
                                </Th>
                                <Th style={{ fontSize: "0.9rem" }} alignCenter>
                                    Data/Hora da Leitura Final
                                </Th>
                                <Th style={{ fontSize: "0.9rem" }} alignCenter>
                                    Diferença de Tempo entre as Leituras
                                </Th>
                            </Tr>
                        </THead>
                        <TBody>
                            {props.item.consumoLeitura.intervalo_faltando_leituras.map((item, i) => {
                                return (
                                    <Tr key={i}>
                                        <Td fontSize={"0.9rem"} alignCenter>
                                            {item.inicio_intervalo_formatado}
                                        </Td>
                                        <Td fontSize={"0.9rem"} alignCenter>
                                            {item.fim_intervalo_formatado}
                                        </Td>
                                        <Td fontSize={"0.9rem"} alignCenter>
                                            {item.diferenca}
                                        </Td>
                                    </Tr>
                                );
                            })}
                        </TBody>
                    </Table>
                </div>
            </ModalAlert>
            {props.item.consumoLeitura.intervalo_faltando_leituras.length ? (
                <Button
                    style={{ cursor: "pointer", backgroundColor: "#d52749", width: props.mobile ? "96%" : 85, paddingInline: 0, paddingBlock: 2, color: "#FFF", borderRadius: 3, margin: props.mobile ? "-5px 0px 2px 0px" : "5px 0px 0px 0px" }}
                    text="Leituras Faltando!"
                    event={() => setModalAberto(true)}
                />
            ) : null}
        </>
    );
}
